import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Check, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, imgUrl } from "@/lib/api";

/** Avant / après envoyés par les clientes : valider (publication en témoignage) ou refuser (photos supprimées). */
export function BeforeAfterSubmissions() {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["admin-before-after"], queryFn: async () => (await api.get("/admin/before-after")).data });
  const list = Array.isArray(data) ? data : [];
  const act = async (id, action) => {
    try {
      const { data: r } = await api.post(`/admin/before-after/${id}/${action}`);
      toast.success(action === "approve" ? `Avant / après publié · code ${r?.reward_code || ""} -15 % envoyé à la cliente` : "Envoi refusé, photos supprimées");
      qc.invalidateQueries();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <section data-testid="admin-before-after" className="rounded-sm border border-[var(--line)] p-5">
      <h3 className="font-display text-2xl">Avant / après reçus <span className="text-[var(--gold-soft)]">({list.length})</span></h3>
      <p className="mt-1 text-xs text-[var(--parchment)]/75">Envoyés depuis /partager-mon-avant-apres. Vérifiez les photos et le texte avant de publier.</p>
      {list.length === 0 ? <p data-testid="admin-before-after-empty" className="mt-4 text-sm text-[var(--parchment)]/80">Aucun envoi en attente.</p> : null}
      <div className="mt-4 grid gap-4 md:grid-cols-2">
        {list.map((s) => (
          <div key={s.id} data-testid={`admin-ba-${s.id}`} className="rounded-sm border border-[var(--line)] p-4">
            <div className="grid grid-cols-2 gap-2">
              {["before", "after"].map((w) => <img key={w} src={imgUrl(`/api/admin/before-after/${s.id}/${w}.webp`)} alt={w === "before" ? "Avant" : "Après"} className="aspect-square w-full rounded-sm object-cover" />)}
            </div>
            <p className="mt-3 text-sm"><b>{s.name}</b>{s.city ? ` · ${s.city}` : ""} · {s.email}</p>
            <p className="text-xs text-[var(--parchment)]/80">{[s.product, s.duration].filter(Boolean).join(" · ")}</p>
            {s.quote ? <p className="mt-2 text-sm italic">« {s.quote} »</p> : null}
            <div className="mt-3 flex gap-2">
              <button data-testid={`admin-ba-approve-${s.id}`} onClick={() => act(s.id, "approve")} className="flex h-9 items-center gap-1 rounded-full bg-[var(--gold)] px-4 text-xs font-semibold text-[var(--ink)]"><Check className="h-3.5 w-3.5" />Publier</button>
              <button data-testid={`admin-ba-reject-${s.id}`} onClick={() => act(s.id, "reject")} className="flex h-9 items-center gap-1 rounded-full border border-[var(--line)] px-4 text-xs"><X className="h-3.5 w-3.5" />Refuser</button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
